import { get, reduce, size } from "lodash"
import { Dispatch } from "redux"

import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { UserStorage } from "utils/userStorage"

/************************************
 * TYPES
 ************************************/
export type UserType = {
  type: string
  data?: APIResponse.Res
}

type ClientSettingType = {
  Key: string
  ChannelId: string
  Value: string
}

/************************************
 * ACTION TYPE
 ************************************/
const REDUX_USER_LOGIN = "REDUX_USER_LOGIN"
const REDUX_USER_LOGOUT = "REDUX_USER_LOGOUT"

const ClientSetting = (data: Array<ClientSettingType>) => {
  return reduce(
    data,
    (res: { [t: string]: string }, row: ClientSettingType) => {
      res[row.Key] = row.Value
      return res
    },
    {}
  )
}
/************************************
 * ACTIONS
 ************************************/
type LoginType = (
  user_branch: string,
  user_id: string,
  password: string,
  cb?: Function
) => any
export const login: LoginType = (user_branch, user_id, password, cb) => {
  return async (dispatch: Dispatch) => {
    const data = await APIs.Account.Login(user_branch, user_id, password)
    await dispatch({ type: REDUX_USER_LOGIN, data: data })
    if (get(data, "Result") === 0) {
      cb && cb()
    }
  }
}

export const sessionLogin: () => { type: string; data: object } = () => {
  const userInfo = UserStorage.User.get()
  if (size(userInfo)) return { type: REDUX_USER_LOGIN, data: userInfo }
}

// 外部からのSSOの仕様決まり次第修正
type SSOLoginType = (
  channel?: string,
  account?: string,
  session_id?: string
) => any
export const SSOLogin: SSOLoginType = (channel, account, session_id) => {
  return async (dispatch: Dispatch) => {
    let user_info = UserStorage.User.get()
    if (!!size(user_info) && get(user_info, "Result") === 0) {
      await dispatch({
        type: REDUX_USER_LOGIN,
        data: user_info,
      })
    } else {
      throw user_info
    }
  }
}

/**
 * ログアウト
 * @returns {{type: string}}
 */
// export function logout() {
//   return async dispatch => {
//     await closeWindows()
//     APIs.User.LogoffChannelSession(app.window.ChannelIDs.order)
//     dispatch({
//       type: REDUX_USER_LOGOUT,
//     })
//   }
// }

/************************************
 * Reducer
 ************************************/
const initialState = {
  UserInfo: {},
  ClientSetting: {},
}

export default (state = initialState, action: UserType) => {
  switch (get(action, "type")) {
    case REDUX_USER_LOGIN:
      // パスワード保存状態
      if (get(action, ["data", "Result"]) === 0) {
        UserStorage.PasswordSetting.set(false)
        UserStorage.User.set(get(action, "data"))
      }

      return {
        ...state,
        UserInfo: get(action, "data"),
        ClientSetting: ClientSetting(get(action, "data.ClientSetting")),
      }
    // ログアウト
    case REDUX_USER_LOGOUT:
      // UserStorage.EquityUser.clear()
      // UserStorage.DerivUser.clear()
      UserStorage.User.clear()
      // UserStorage.AgencyLogin.remove()
      // UserStorage.TransitSSOLogin.remove()
      // UserStorage.Commision.clear()
      // CheckSessionPolling.stop()
      return initialState

    default:
      return state
  }
}
